import { ExternalLinkIcon, LogOutIcon } from 'assets';
import { useUserLogOut } from 'view/pages/auth/hooks/useUserLogOut';
import { Location, useLocation } from 'react-router-dom';
import { userProfileExternalMenu, userProfileMenu } from 'view/pages/profile/helpers';
import { useNavigate } from 'react-router';
import { useGetPrivacyAndTerms } from 'view/pages/auth/hooks/useGetPrivacyAndTerms';
import { useContextSelector as useCS } from 'use-context-selector';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import * as S from './styled';

const UserProfileMenu = () => {
  const location: Location = useLocation();
  const navigate = useNavigate();
  const { send } = useUserLogOut();
  const { getPrivacyAndTerms } = useGetPrivacyAndTerms();
  const { role } = useCS(GlobalConfigContext, globalConfigSelectors.userData);

  const filteredMenu = userProfileMenu.filter((menuItem: any) => {
    if (menuItem.recruiterOnly) {
      return role?.name === RolesEnum.RECRUITER;
    }
    return true;
  });

  return (
    <S.MenuBlock>
      <S.MainMenuBlock>
        {filteredMenu.map((menuItem) => {
          return (
            <S.MenuItemLink
              key={menuItem.id}
              /* href={menuItem.link} */
              onClick={() => {
                return navigate(menuItem.link);
              }}
              selected={menuItem.link === location.pathname}
            >
              {menuItem.text}
            </S.MenuItemLink>
          );
        })}
      </S.MainMenuBlock>
      <S.MainMenuBlock>
        {userProfileExternalMenu.map((menuItem) => {
          return (
            <S.MenuItemLink
              key={menuItem.id}
              /* href={menuItem.link} */
              onClick={() => {
                if (menuItem.link === 'termsAndConditions' || menuItem.link === 'privacyPolicy') {
                  getPrivacyAndTerms(menuItem.link);
                  return;
                }
                navigate(menuItem.link);
              }}
              selected={
                menuItem.link === location.pathname && location.pathname === '/profile/help-center'
              }
              target={menuItem.target}
            >
              {menuItem.text} {menuItem.endIcon ? <ExternalLinkIcon /> : null}
            </S.MenuItemLink>
          );
        })}
      </S.MainMenuBlock>
      <S.MenuExternalItemLink
        onClick={() => {
          return send();
        }}
      >
        Sign Out <LogOutIcon />
      </S.MenuExternalItemLink>
    </S.MenuBlock>
  );
};

export default UserProfileMenu;
